
import { Nav } from './components/nav'
import { Module09Slider } from './modules/module-09-slider'
import { Module11Collections } from './modules/module-11-collections'
import { Module12Faq } from './modules/module-12-faq'
import { Module17Anchor } from './modules/module-17-anchor'
import { Module00Filters } from './modules/module-00-filters'
import { Module00Specs } from './modules/module-00-specs'
import { TimepiecesInfo } from './components/timepieces-info'
import { Module06Media } from './modules/module-06-media'
import { Module00NewsQuery } from './modules/module-00-news-query'
import { Module14Map } from './modules/module-14-map'
import { ContactForm } from './modules/template-contact'
import { SmoothScroll } from './components/smooth-scroll'
import { ScrollAnimations } from './components/scroll-animations'
import { PageLoad } from './components/page-load'
import { MobileVideo } from './components/mobile-video'
import { Loader } from './components/loader'
import { CookieConsent } from './components/cookie-consent'

function applyNoise(size = 200, opacity = 0.15) {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  const img = ctx.createImageData(size, size);
  for (let i = 0; i < img.data.length; i += 4) {
    const v = (Math.random() * 255) | 0;
    img.data[i] = img.data[i+1] = img.data[i+2] = v;
    img.data[i+3] = Math.round(opacity * 255);
  }
  ctx.putImageData(img, 0, 0);
  document.documentElement.style.setProperty('--noise', `url(${canvas.toDataURL()})`);
}

// Track timepiece visits across SPA navigation — stored in sessionStorage so the
// contact form can pre-fill the "timepiece_sought" field with everything viewed this session.
function trackTimepieceVisit() {
  const titleEl = document.querySelector('.timepieces-info .title')
  if (!titleEl) return
  const title = titleEl.textContent.trim()
  if (!title) return

  // counts: { "Dimier – Récital 28": 2, … }
  // Discard legacy array format if still in sessionStorage from a previous version
  const raw = JSON.parse(sessionStorage.getItem('bovet_viewed_timepieces') || '{}')
  const counts = Array.isArray(raw) ? {} : raw
  counts[title] = (counts[title] || 0) + 1
  sessionStorage.setItem('bovet_viewed_timepieces', JSON.stringify(counts))
  sessionStorage.setItem('bovet_last_timepiece', title)
}

// Re-runs on every AJAX page load to bind modules to the new DOM
function initPageModules() {
  trackTimepieceVisit()
  new ScrollAnimations();

  if (document.querySelector('.module-09-slider'))                  new Module09Slider();
  if (document.querySelector('.module-11-collections'))             new Module11Collections();
  if (document.querySelector('.module-12-faq'))                     new Module12Faq();
  if (document.querySelector('.module-17-anchor'))                  new Module17Anchor();
  // if (document.querySelector('.module-00-filters'))                 new Module00Filters();
  if (document.querySelector('.module-00-specs'))                   new Module00Specs();
  if (document.querySelector('.timepieces-info'))                   new TimepiecesInfo();
  if (document.querySelector('.module-06-media .video-play-pause')) new Module06Media();
  if (document.querySelector('.module-00-news-query'))              new Module00NewsQuery();
  if (document.querySelector('.module-14-map'))                     new Module14Map();
  if (document.querySelector('video source[data-src]'))              new MobileVideo();
  if (document.querySelector('.template-contact')) {
    new ContactForm();
    if (window.jQuery) {
      // Ask Formidable to re-run its own setup (conditional logic, validators,
      // and file upload Dropzone init). frmPageChanged is the event Formidable
      // Pro listens to — it calls checkFieldsOnPage() which calls loadDropzones().
      jQuery(document).trigger('frmPageChanged')
    }
    // Formidable's JS-spam-check requires a hidden field (frm_submit_entry_{key})
    // to have a non-empty value — its own document.ready handler sets this but
    // never re-runs on SPA navigation. Set it manually as a reliable fallback.
    document.querySelectorAll('input[id^="frm_submit_entry_"]').forEach(input => {
      if (!input.value) {
        input.value = input.id.replace('frm_submit_entry_', '')
      }
    })
  }
}

window.onload = function() {
  applyNoise();

  // Persistent singletons — initialized once, survive page swaps
  new Nav();
  window.__smoothScroll = new SmoothScroll();
  new PageLoad();

  // Expose for PageLoad to call after each SPA navigation
  window.initApp = initPageModules;

  // Page modules init only after the loader exits so animations don't
  // play while the loader is still covering the page
  new Loader(() => {
    initPageModules();
    new CookieConsent();
  });
};
